import { LoadingButton } from '@mui/lab'
import { Box, Card, CardContent, TextField, Typography } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { useCreateLeadsMutation } from '~/app/store/services'
import { getErrorMessage } from '~/utils'

export default function LeadForm({ id, onClose }: any) {
  const [state, setState] = useState({ name: '', email: '' })
  const [createLead, { isLoading }] = useCreateLeadsMutation()
  const handleSubmit = async (e: any) => {
    e.preventDefault()
    try {
      const data = await createLead({ ...state, id }).unwrap()
      enqueueSnackbar(data.message, { variant: 'success' })
      onClose()
    } catch (error) {
      getErrorMessage(error)
    }
  }
  const onChange = (e: any) => {
    setState({ ...state, [e.target.name]: e.target.value })
  }

  const getProps = (name: keyof typeof state) => ({
    onChange,
    value: state[name],
    name,
    label: name.charAt(0).toUpperCase() + name.slice(1),
    fullWidth: true,
    required: true,
  })

  return (
    <Box
      component={'form'}
      onSubmit={handleSubmit}
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ padding: '16px 24px' }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Provide your name and email to receive your KYC report
        </Typography>
        <TextField {...getProps('name')} margin="normal" />
        <TextField {...getProps('email')} margin="normal" type="email" />
      </Box>
      <Box
        // position="absolute"
        // bottom={0}
        width="100%"
        padding={2}
        borderTop="1px solid #E0E0E0"
      >
        <LoadingButton
          loading={isLoading}
          type="submit"
          variant="contained"
          fullWidth
          sx={{ px: 2, py: 1.5 }}
        >
          Get KYC Report
        </LoadingButton>
      </Box>
    </Box>
  )
}
